import React from 'react';

interface Props {
  className?: string;
}

const Storage: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Vector">
      <path
        d="M7.43078 18.7384H5.72308V20.1692H7.43078V18.7384Z"
        fill="currentColor"
      />
      <path
        d="M7.43078 8.95381H5.72308V11.0154H7.43078V8.95381Z"
        fill="currentColor"
      />
      <path
        d="M7.43078 15.4769H5.72308V17.5384H7.43078V15.4769Z"
        fill="currentColor"
      />
      <path
        d="M7.43078 12.2153H5.72308V14.2769H7.43078V12.2153Z"
        fill="currentColor"
      />
      <path d="M20 6.32307H8.58459V20.1692H20V6.32307Z" fill="currentColor" />
      <path
        d="M4.56923 6.32307H0V20.1692H4.56923V6.32307Z"
        fill="currentColor"
      />
      <path
        d="M7.43078 6.32307H5.72308V7.75384H7.43078V6.32307Z"
        fill="currentColor"
      />
      <path
        d="M20 4.78462L11.123 1.7077V0.830765H8.89235V1.7077L0 4.78462H20Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Storage;
